import { Model, PagedResponse } from "../types";

export const isOrphanPage = (
  pagedResponse: PagedResponse<unknown>
): { isOrphan: false } | { isOrphan: true; maxRemainingPageIndex: number } => {
  const { page, pageSize, count } = pagedResponse;

  if (count > 0) {
    if (Math.ceil(count / pageSize) < page + 1) {
      // we have asked for a page that is beyond the actual number of pages present in the total count
      const maxRemainingPageIndex = Math.floor((count - 1) / pageSize);
      return { isOrphan: true, maxRemainingPageIndex };
    } else {
      return { isOrphan: false };
    }
  } else {
    // count === 0 is a different case, as we have no records but do not want to suggest
    //  to go to an earlier page to find some, as we have no pages to suggest
    if (page === 0) {
      return { isOrphan: false };
    } else {
      return { isOrphan: true, maxRemainingPageIndex: 0 };
    }
  }
};

export const PagedResponseTo = <T>(
  pagedResponse: PagedResponse<Model>,
  mapper: (model: Model) => T
) => {
  return {
    ...pagedResponse,
    data: pagedResponse.data.map((item) => mapper(item)),
  };
};
